var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"circular-progress"},[_c('apexchart',{attrs:{"type":"radialBar","options":_vm.chartOptions,"series":[_vm.value],"width":"150"}}),_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"count"},[_vm._v(_vm._s(_vm.count))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }